// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4z-1";
export var standaloneTable = "_4z-0";